import { FunctionComponent, useEffect, useState } from "react";
import "./SortIndicator.css"

interface SortIndicatorProps {
    isAsc?: boolean,
    isActive?: boolean
}
 
const SortIndicator: FunctionComponent<SortIndicatorProps> = (props) => {
    let {isAsc, isActive} = props;

    return (  
        <div className={`sort-indicator  ${isAsc ? 'ASC' : 'DESC'} ${isActive ? 'active':''}`}>
            <div className="sort-asc"></div>
            <div className="sort-desc"></div>
        </div>
    );
}
 
export default SortIndicator;